import { create } from "zustand";

import type { EventDetail } from "@/types/event";

interface WaitlistCancellationState {
  event: EventDetail | null;
  tenantSubDomain: string | null;
  cancelled: boolean;
  prepare: (event: EventDetail, tenantSubDomain: string) => void;
  complete: (event: EventDetail, tenantSubDomain: string) => void;
  dismiss: () => void;
}

// Independent of the selected patient/event: calendar refetches can unmount
// the cancelling row before its mutation resolves.
export const useWaitlistCancellationStore = create<WaitlistCancellationState>(
  (set) => ({
    event: null,
    tenantSubDomain: null,
    cancelled: false,
    prepare: (event, tenantSubDomain) =>
      set({ event, tenantSubDomain, cancelled: false }),
    complete: (event, tenantSubDomain) =>
      set({ event, tenantSubDomain, cancelled: true }),
    dismiss: () =>
      set({ event: null, tenantSubDomain: null, cancelled: false }),
  }),
);
